// Bannière cookies + Consent Mode v2 (package interne consent-manager, cf. README du package).
// Le défaut de consentement est posé plus tôt, par le snippet inline de nuxt.config head.script.
// Import depuis la racine du package : webpack 4 ignore le champ `exports` qui expose
// `consent-manager/adapters/nuxt2-plugin`.
import { createConsentPlugin } from 'consent-manager'
import { buildConsentBridge, injectSiteStyleOverrides, revealReopenerIfDecided } from './consent-bridge'

const plugin = createConsentPlugin({
  theme: {
    primaryColor: '#0097A7',
    primaryHoverColor: '#007C8A',
    backgroundColor: '#06132F',
    textColor: '#FFFFFF',
    textSecondaryColor: '#C7D0DC',
    borderColor: '#1E2B47'
  },
  texts: {
    privacyLink: '/content/2-mentions-legales',
    categories: {
      necessary: {
        cookies: [
          { name: 'Tidio', description: 'Chat avec le service client', duration: 'session' },
          { name: 'Panier et connexion', description: 'Fonctionnement de la boutique', duration: '13 mois' }
        ]
      },
      analytics: {
        cookies: [
          { name: 'Google Analytics', description: 'Mesure d\'audience et statistiques de navigation', duration: '13 mois' },
          { name: 'Hotjar', description: 'Analyse d\'ergonomie (cartes de chaleur)', duration: '13 mois' }
        ]
      },
      marketing: {
        cookies: [
          { name: 'Google Ads', description: 'Mesure des conversions publicitaires', duration: '13 mois' }
        ]
      }
    }
  }
})

export default function (ctx, inject) {
  plugin(ctx, inject)
  injectSiteStyleOverrides(document)
  revealReopenerIfDecided(document, !!ctx.app.$consent && !!window.localStorage.getItem('__cm_consent'))
  window.dataLayer = window.dataLayer || []
  buildConsentBridge(ctx.app.$consent, window.dataLayer)
}
